import type { FC } from 'react';
import React, { useCallback, useRef, useState } from 'react';
import cn from 'classnames';
import useClickAway from 'react-use/lib/useClickAway';
import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';

import type { TSearchBlock } from '../models';
import { useSearch } from '../hooks/use-search';
import { useSearchQuery } from '../hooks/use-search-query';

export const SearchBlock: FC<TSearchBlock> = ({
    DefaultRequests,
    Results,
    SearchBar,
    SearchForm,
    analytics,
    featuredAds,
    featuredRequests,
    innerRef,
    styles,
}) => {
    const [state, setState, resetState] = useSearchQuery('');

    const [isFocused, setFocus] = useState(false);

    const formRef = useRef<HTMLFormElement>(null);

    useClickAway(formRef, () => {
        setFocus(false);
        sendEvent(analytics?.closeSearch);
        resetState();
    });

    const focusInput = useCallback(() => {
        setFocus(true);
        sendEvent(analytics?.focusInput);
    }, [analytics?.focusInput]);

    // отключено до лучших времен, до тех пока бекенд не добавить апи для подсказок
    // const autoSuggests = useAutosuggests(state);
    // const autocompleteWord = `${state}${autoSuggests[0]?.slice(state.length) ?? ''}`;

    const searchResults = useSearch(state, featuredAds);

    const showDefaultRequests = isFocused && state.length < 3;

    const showResults = isFocused && state.length > 2 && searchResults.length > 0;

    return (
        <SearchForm ref={formRef} request={state.trim()}>
            <SearchBar
                // autocompleteWord={autocompleteWord}
                forwardedRef={innerRef}
                onChange={setState}
                onClearClick={resetState}
                onFocus={focusInput}
                value={state}
            />
            {showDefaultRequests && (
                <div className={styles.dropdown}>
                    <DefaultRequests analytics={analytics} featuredRequests={featuredRequests} />
                </div>
            )}
            {showResults && (
                <div className={styles.dropdown}>
                    <Results
                        analytics={analytics}
                        items={searchResults}
                        listClassName={cn(styles.external, styles.resultList)}
                        searchWord={state}
                    />
                </div>
            )}
        </SearchForm>
    );
};
